export default function updateGroups(groupsNew, groups, setContext) {
  let resGroups = groups;
  for (const group in groupsNew) {
    if (!resGroups[group]) resGroups[group] = groupsNew[group];
  }
  setContext((Prev) => {
    return { ...Prev, groups: resGroups };
  });
}
